$(document).ready(function() { /*-------Document ready start--------*/


    setTimeout(function(){

      if ($('.custom_product_variants').hasClass('sku_combination-true')) {
          var metafield_variants = $('.custom_product_variants.sku_combination-true').find('ul').html();
          console.log(metafield_variants);
          if (metafield_variants) {
              $('.hide_default_color .swatch--gl[data-option-index="0"] ul li:last-child').after(metafield_variants);
              $('.hide_default_color').find('.swatch--gl[data-option-index="0"]').show();
          }
      }

    },2000);





   $('body').on('click','.layout-column3 .custom_atc_button',function(event){
     event.preventDefault();
     var column2_qnty = $('.layout-column2 .quantity-input .quantity-input-field').val();
     var column3_qnty = $('.layout-column3 .quantity__selector .quantity__input').val();



    $('.layout-column2 .quantity-input .quantity-input-field').val(column3_qnty);
     
     if($('.layout-column2 .button-add-to-cart').hasClass('po-atc-btn')){
         $('.layout-column2 .button-add-to-cart.po-atc-btn').trigger('click');
     }else{
        $('.layout-column2 .button-add-to-cart').trigger('click');
     }
     
   });



//Append notify me 
function NotifyMe(){
  if($('.layout-column2 .button-add-to-cart').hasClass('hengam-preorder-button')){
    $('.layout-column3 .app_custom_btn').show();
    $('.layout-column3 .custom_atc_button.first-btn').hide();
    $('.layout-column3 .product-actions-buy-now').hide();

  }
}

  
// Append price table
  function AddTable(){
    var table_data = $('.template-product #lb-volume-discount').html()
    $('.column_three_table,.mobile_price_table').html(table_data);
   }
    
    setTimeout(function(){
      AddTable();
    },800);
    setTimeout(function(){
      AddTable();
      NotifyMe();
    },1000);
    setTimeout(function(){
      AddTable();
    },1500);
    setTimeout(function(){
      AddTable();
    },1800);
    setTimeout(function(){
      AddTable();
      NotifyMe();
    },2000);
    setTimeout(function(){
      AddTable();
      NotifyMe();
    },2500);
    setTimeout(function(){
      AddTable();
      NotifyMe();
    },3000);
  


$('body').on('click','.layout-column3 .btn-quantity',function(){
        let $input = $(this).siblings('.quantity');
        let currentValue = parseInt($input.val(), 10) || 1;

        if ($(this).hasClass('plus')) {
            $input.val(currentValue + 1);
        } else if ($(this).hasClass('minus')) {
            if (currentValue > 1) {
                $input.val(currentValue - 1);
            }
        }
         var quantity = $('.product_view-popup .quantity').val();
    });



$('body').on('change','.layout__three_column .swatch--gl.clearfix[data-option-index="0"] ul input',function(){
  setTimeout(function(){
  var mainprice = $('.layout-column2').find('.price-container').html();
  $('.layout-column3').find('.price-container').html(mainprice);

},1000);
 });



   }); /*-------Document ready close--------*/


